mutation NotePurchaseOrderCreate($input: NotePurchaseOrderCreateInput!) {
  notePurchaseOrderCreate(input: $input) {
    note {
      id
      noteComment
      _rowTimestamp
    }
  }
}
